
import {computed, defineComponent, PropType} from "vue";
import MarkdownEditor from "../Forms/MarkdownEditor.vue";
import { MarkdownContent } from 'hjelseth-richeditor'

export default defineComponent({
  components: {MarkdownContent, MarkdownEditor},
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: () => "view",
      validator: (value: string) => {
        return ["view", "edit"].indexOf(value) !== -1;
      },
    },
    error: {
      type: Object as PropType<string | null>,
      required: false,
    },
    title: {
      type: Object as PropType<string | null>,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    return {
      value,
    };
  },
});
